// The board game moves' contract between words-happen-gql and the game app (WH-154): the error numbers a move that
// can't be judged at all is answered with. A move the rules refuse is a MoveRefused result, not an error.
// words-happen-service gives each the code `<serviceCode>:<number>`; the app matches on the number, as for the lobby's
// (GAME_LOBBY_ERROR_NUMBERS).

/** The number of each move error's code. */
export const GAME_MOVE_ERROR_NUMBERS = {
  /** An unknown game, or one the caller isn't seated in. The same number as the lobby's. */
  gameNotFound: '015',
  /** Any server error; the app can offer to try again. */
  gameUnavailable: '016',
  /** The game is waiting, finished or cancelled. */
  gameNotActive: '025',
  /** The game has moved past the turn the caller saw, by another request or a retry of one already written. */
  staleTurn: '026',
  /** It is the other seat's turn. */
  notYourTurn: '027',
  /** Too many tiles, a tile ID that isn't one, or a bad position, direction or letter: refused before the rules. */
  moveMalformed: '028',
} as const;

export type GameMoveErrorKind = keyof typeof GAME_MOVE_ERROR_NUMBERS;

/** The move error an API error code is, whatever the service code; undefined for any other code. */
export const gameMoveErrorKind = (errorCode: string | undefined): GameMoveErrorKind | undefined =>
  (Object.keys(GAME_MOVE_ERROR_NUMBERS) as GameMoveErrorKind[]).find((kind) =>
    errorCode?.endsWith(`:${GAME_MOVE_ERROR_NUMBERS[kind]}`),
  );
